/**
 * The resolution scope of an effective ingredient nutrition/physical result:
 *
 * * `CUSTOM`          - a tenant-owned custom Ingredient, carrying its own
 *                       tenant-scoped profile and physical factors.
 * * `GLOBAL_OVERRIDE` - a global Ingredient with this tenant's sparse override
 *                       applied (alias and/or physical factors and/or a tenant
 *                       nutritional profile attached via the override).
 * * `GLOBAL`          - an unmodified global Ingredient (curated profile and
 *                       physical factors).
 *
 * Returned explicitly so a caller never has to re-derive which branch won.
 */
export const NUTRITION_SCOPES = ['CUSTOM', 'GLOBAL_OVERRIDE', 'GLOBAL'] as const;
export type NutritionScope = (typeof NUTRITION_SCOPES)[number];
